export function RootErrorFallback() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
      <h1 className="text-xl font-semibold text-ink-900">Er ging iets mis</h1>
      <p className="max-w-md text-sm text-ink-500">
        De pagina kon niet worden geladen. Probeer het opnieuw of neem contact op met de beheerder
        als het probleem aanhoudt.
      </p>
      <button
        type="button"
        className="rounded-4 border border-line-strong bg-surface px-4 py-2 text-sm text-ink-900"
        onClick={() => window.location.reload()}
      >
        Pagina opnieuw laden
      </button>
    </div>
  );
}
